"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INDIVIDUAL_INSURANCE_NUMBER_MASK = exports.DRIVER_LICENSE_MASK = exports.PASSPORT_MASK = exports.EPTS_REG_EXP = exports.PTS_REG_EXP = exports.STS_REG_EXP = exports.LICENSE_REG_EXP = exports.PASSPORT_CODE_REG_EXP = exports.PASSPORT_REG_EXP = exports.CAR_NUMBER_REG_EXP = exports.ADDRESS_REG_EXP = exports.PET_NAME_REG_EXP = exports.PROMO_REG_EXP = exports.MAX_LENGTH_100 = exports.MAX_LENGTH = exports.NON_LATIN_REG_EXP = exports.ONLY_CYRILLIC = exports.ONLY_LETTERS = exports.AGE_REG_EXP = exports.ZERO_AT_START = exports.DIGITS_AND_CYRILLIC_REG_EXP = exports.ONLY_NUMBERS = exports.NOT_DIGIT_REG_EXP = exports.DIGITS_REG_EXP = exports.EMAIL_REG_EXP = exports.PHONE_REG_EXP = void 0;
exports.PHONE_REG_EXP = /^(\+7|8)?[\s\-]?\(?[4890][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;
exports.EMAIL_REG_EXP = /^(?=.{1,64}@)[A-Za-zА-Яа-я0-9_+-]+(\.[A-Za-zА-Яа-я0-9_+-]+)*@[^-][A-Za-zА-Яа-я0-9-]+(\.[A-Za-zА-Яа-я0-9-]+)*(\.[A-Za-zА-Яа-я]{2,})$/u;
exports.DIGITS_REG_EXP = /[0-9]/;
exports.NOT_DIGIT_REG_EXP = /\D/g;
exports.ONLY_NUMBERS = /^\d+$/;
exports.DIGITS_AND_CYRILLIC_REG_EXP = /[0-9А-ЯABEKMHOPCTYX]/i;
exports.ZERO_AT_START = /^(0[0-9])/;
exports.AGE_REG_EXP = /^(?:[0-9]|[1-8][0-9]|90)$/;
exports.ONLY_LETTERS = /^[а-яА-Яa-zA-Z]/;
exports.ONLY_CYRILLIC = /^[а-яА-ЯЁё\s'-]+$/;
exports.NON_LATIN_REG_EXP = /^[^a-zA-Z]*$/;
exports.MAX_LENGTH = /^.{1,50}$/;
exports.MAX_LENGTH_100 = /^.{1,100}$/;
exports.PROMO_REG_EXP = /^[A-Za-zА-Яа-яЁё0-9. _]{1,20}$/;
exports.PET_NAME_REG_EXP = /^[A-Za-zА-Яа-яЁё0-9. _-]{1,40}$/;
exports.ADDRESS_REG_EXP = /^[а-яА-ЯёЁ0-9]+([ \-.,:/]?[а-яА-ЯёЁ0-9]+)*[ \-.,:/]?$/;
exports.CAR_NUMBER_REG_EXP = /^[АВЕКМНОРСТУХавекмнорстухFDTRVYJHCNEfdtrvyjhcne]\d{3}[АВЕКМНОРСТУХавекмнорстухFDTRVYJHCNEfdtrvyjhcne]{2}\d{2,3}$/;
exports.PASSPORT_REG_EXP = /^(\d{2}\s?\d{2})( \d{6})$/;
exports.PASSPORT_CODE_REG_EXP = /^\d{3}-?\d{3}$/;
exports.LICENSE_REG_EXP = /^(\d{2} [\dА-ЯABEKMHOPCTYX]{2}) (\d{6})$/;
exports.STS_REG_EXP = /^([0-9]{2}\s[АВЕКМНОРСТУХABEKMHOPCTYX0-9]{2})\s([0-9]{6})$/;
exports.PTS_REG_EXP = /^([0-9]{2}\s[АВЕКЛМНОРСТУХЮПABEKMHOPCTYX0]{2})\s([0-9]{6})$/;
exports.EPTS_REG_EXP = /^([1-3][0-9]{3})(0[1-4][0-9]{9})$/;
exports.PASSPORT_MASK = [
    /[0-9]/,
    /[0-9]/,
    ' ',
    /[0-9]/,
    /[0-9]/,
    ' ',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
];
exports.DRIVER_LICENSE_MASK = [
    /[0-9]/,
    /[0-9]/,
    ' ',
    /[0-9]/,
    /[0-9]/,
    ' ',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
];
exports.INDIVIDUAL_INSURANCE_NUMBER_MASK = [
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    ' ',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    ' ',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    ' ',
    /[0-9]/,
    /[0-9]/,
];
